'use client';

/**
 * VerticalFinalCTA — thin wrapper around the shared FinalCTA section.
 *
 * Kept as a named entry-point so the 4 vertical pages (retail, services,
 * events, b2b) can continue importing from `_shared/vertical/` alongside
 * the rest of their template components. The actual rendering lives in
 * `_shared/sections/FinalCTA.tsx`.
 */

import React from 'react';
import FinalCTA from '../sections/FinalCTA';
import type { FinalCTACopy, VerticalAccent } from './types';

type Props = {
  accent: VerticalAccent;
  copy: FinalCTACopy;
};

const VerticalFinalCTA = ({ accent, copy }: Props) => <FinalCTA accent={accent} copy={copy} />;

export default VerticalFinalCTA;
